import React, { Component } from 'react';
import { connect } from 'react-redux';

// Components
import SidePanel, { SidePanelHeader } from '../../../../../components/SidePanel';
import SubscribersTable from './SubscribersTable';
import Button from '../../../../../components/Button';
import LoadingIndicator from '../../../../../components/LoadingIndicator';
import EmptyState from '../../../../../components/EmptyState';
import SubscriberForm from './SubscriberForm';

// Redux
import { getCompanyNotificationSubs, deleteCompanyNotificationSub, addCompanyNotificationSub, updateCompanyNotificationSub } from '../../../../../redux/admin-notification-settings';
import { getNotificationSubsUI, getDeleteNotificationSubUi } from '../../../../../redux/selectors';
import AlertMessage from '../../../../../components/AlertMessage';

class NotificationSettingsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addSubscriberFormIsVisible: false,
    };
  }

  componentDidMount() {
    this.getCompanyNotificationSubs();
  }

  getCompanyNotificationSubs = () => {
    const { dispatch, companyData } = this.props;

    dispatch(getCompanyNotificationSubs(companyData.id));
  }

  deleteSubscriber = (userId) => {
    const { dispatch, companyData } = this.props;

    dispatch(deleteCompanyNotificationSub(userId))
      .then(
        // success
        () => {
          dispatch(getCompanyNotificationSubs(companyData.id));
          this.subscribersTableRef._dismissDeletePrompt();
        },
        // error
        () => {},
      );
  }

  addNewSubscriber = (data) => {
    const { dispatch, companyData } = this.props;

    dispatch(addCompanyNotificationSub(data, companyData.id))
      .then(
        // Success
        () => {
          dispatch(getCompanyNotificationSubs(companyData.id));
          this._toggleSubscriberForm();
        },
        // Error
        () => {},
      );
  }

  editSubscriber = (data, subscriber) => {
    const { dispatch, companyData } = this.props;

    dispatch(updateCompanyNotificationSub(data, companyData.id, subscriber))
      .then(
        // Success
        () => {
          dispatch(getCompanyNotificationSubs(companyData.id));
          this.subscribersTableRef._dismissSubscriberEdit();
        },
        // Error
        () => {},
      );
  }

  _toggleSubscriberForm = (newState) => {
    // Dismiss edit form, if any
    if (this.subscribersTableRef) {
      this.subscribersTableRef._dismissSubscriberEdit();
    }

    this.setState({
      addSubscriberFormIsVisible: newState,
    });
  }

  render() {
    const {
      onDismiss,
      companyData,
      subscribers,
      subscribersUi,
      deleteNotificationSubUi,
    } = this.props;

    const {
      addSubscriberFormIsVisible,
    } = this.state;

    return (
      <SidePanel>
        <SidePanelHeader
          title={`Configurar notificações para ${companyData.corporateName}`}
          onDismiss={onDismiss}
        />

        {/* ======================== */}
        {/* ====== EMPTY STATE ===== */}
        {/* ======================== */}
        {
          subscribers.length === 0 &&
          !subscribersUi.isFetching &&
          !subscribersUi.error &&
          <EmptyState
            className="NotificationSettingsModal__empty-state"
            message="Nenhum usuário encontrado para esta empresa."
          />
        }

        {/* ======================== */}
        {/* ====== ERROR STATE ===== */}
        {/* ======================== */}
        {
          subscribersUi.error &&
          <AlertMessage
            className="NotificationSettingsModal__error-state"
            message="Ocorreu um erro ao carregar a lista de usuários."
            error
            box
            actionText="Tentar Novamente"
            onRetry={this.getCompanyNotificationSubs}
          />
        }

        {/* =============================== */}
        {/* ====== ERROR STATE DELETE ===== */}
        {/* =============================== */}
        {
          deleteNotificationSubUi.error &&
          <AlertMessage
            className="NotificationSettingsModal__error-state"
            message="Ocorreu um erro ao deletar este usuário. Por favor, tente novamente."
            error
            box
          />
        }

        {/* ======================== */}
        {/* ===== NORMAL STATE ===== */}
        {/* ======================== */}
        {
          subscribers.length > 0 &&
          <SubscribersTable
            ref={(child) => { this.subscribersTableRef = child; }}
            subscribers={subscribers}
            onSubDelete={this.deleteSubscriber}
            onSubEdit={this.editSubscriber}
            onEditOpen={() => { this._toggleSubscriberForm(false); }}
          />
        }

        {/* ======================== */}
        {/* ==== LOADING STATE ===== */}
        {/* ======================== */}
        {
          subscribersUi.isFetching &&
          <LoadingIndicator
            text="Carregando..."
            theme="dark"
            className="NotificationSettingsModal__loading-indicator"
          />
        }

        {/* ======================== */}
        {/* === SUBSCRIBER FORM  === */}
        {/* ======================== */}
        {
          !addSubscriberFormIsVisible &&
          !subscribersUi.isFetching &&
          !subscribersUi.error &&
          <div className="NotificationSettingsModal__add-new-user">
            <Button
              skin="primary"
              text={subscribers.length > 0 ? 'Adicionar outro usuário' : 'Adicionar usuário'}
              onClick={() => { this._toggleSubscriberForm(true); }}
            />
          </div>
        }

        {
          addSubscriberFormIsVisible &&
          <SubscriberForm
            onDismiss={() => { this._toggleSubscriberForm(false); }}
            onSubmit={this.addNewSubscriber}
          />
        }

      </SidePanel>
    );
  }
}

function mapStateToProps(state) {
  return {
    subscribers: state.adminNotificationSettings.notificationSubs.data,
    subscribersUi: getNotificationSubsUI(state),
    deleteNotificationSubUi: getDeleteNotificationSubUi(state)
  };
}

export default connect(mapStateToProps)(NotificationSettingsModal);
